import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service, Timeframe } from 'webapp-types';
import type { TimeframeType } from 'webapp/enums/enums';

import ToolTipComponent from 'webapp/components/tool-tip';

interface Args {
	type: TimeframeType | null;
	year: number;
	selected: Timeframe | null | undefined; // null means continuous, undefined means nothing is selected
	onChange: (type: TimeframeType | null, year: number) => void;
	dateLabel?: string;
	isDisabled?: boolean;
	tooltipText?: string;
}

export default class CommonTimeframePopupItemComponent extends Component<Args> {
	@service('timeframe') declare timeframeService: Service.Timeframe;

	get label() {
		const type = this.args.type;
		let label = this.timeframeService.getTimeframeString(
			type !== null ? { type, year: this.args.year } : null,
		);
		if (this.args.dateLabel) {
			label += ` (${this.args.dateLabel})`;
		}
		return label;
	}

	get isSelected() {
		const selected = this.args.selected;
		if (selected) {
			return selected.type === this.args.type && selected.year === this.args.year;
		} else {
			return selected === null && this.args.type === null;
		}
	}

	get isDisabled() {
		return !!this.args.isDisabled;
	}

	@action
	onChange() {
		this.args.onChange(this.args.type, this.args.year);
	}
	<template>
		{{#if @tooltipText}}
			<div class="timeframe-item-wrapper">
				<a
					role="button"
					class="{{if this.isSelected 'selected'}} {{if this.isDisabled 'disabled'}}"
					{{on "click" this.onChange}}
				>{{this.label}}
				</a>
				<ToolTipComponent @text={{@tooltipText}} @position="top" />
			</div>
		{{else}}
			<a
				role="button"
				class="{{if this.isSelected 'selected'}} {{if this.isDisabled 'disabled'}}"
				{{on "click" this.onChange}}
			>{{this.label}}
			</a>
		{{/if}}
	</template>
}
